import { render, staticRenderFns } from "./DifferentiatingBenefits.vue?vue&type=template&id=44cf4616"
import script from "./DifferentiatingBenefits.vue?vue&type=script&lang=ts"
export * from "./DifferentiatingBenefits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports